type Screen={view:string;filter:string;search:string};
export function createNavigation(ui:any){
 let ready=false,depth=0;
 const owner=()=>ui.owner();
 function url(screen:Screen){
  const params=new URLSearchParams();if(screen.view!=='dashboard')params.set('view',screen.view);if(screen.filter)params.set('filter',screen.filter);
  return '/'+(params.size?'?'+params:'');
 }
 function remember(){
  if(!ready||!owner())return;
  const screen:Screen=ui.screen();
  history.replaceState({tvdeNavigation:true,owner:owner(),depth,...screen,lists:ui.capture(),scrollY:window.scrollY},'',url(screen));
 }
 function restore(){
  const params=new URLSearchParams(location.search),requested=params.get('view')||'dashboard',view=ui.allowed(requested)?requested:'dashboard';
  const requestedFilter=params.get('filter')||'';
  const filter=view==='driver-profile'&&/^[0-9a-f]{8}(?:-[0-9a-f]{4}){3}-[0-9a-f]{12}$/i.test(requestedFilter)?requestedFilter:requestedFilter==='active'&&['drivers','assignments'].includes(view)?'active':view==='pending'&&/^attention\.(driver|vehicle|person|organization)\.[0-9a-f-]{36}$/i.test(requestedFilter)?requestedFilter:'';
  const state=history.state?.tvdeNavigation&&history.state.owner===owner()&&history.state.view===view&&history.state.filter===filter?history.state:null;
  depth=state&&Number.isSafeInteger(state.depth)?Math.max(0,state.depth):0;
  ui.apply({view,filter,search:typeof state?.search==='string'?state.search.slice(0,500):''});ui.restore(state?.lists);
  ready=true;return Number.isFinite(state?.scrollY)?state.scrollY:0;
 }
 function push(view:string,filter=''){
  remember();ui.close();ui.apply({view:ui.allowed(view)?view:'dashboard',filter,search:''});ui.restore(null);depth++;
  history.pushState({tvdeNavigation:true,owner:owner(),depth,...ui.screen()},'',url(ui.screen()));ready=true;
 }
 async function go(view:string,filter=''){
  push(view,filter);await ui.load();window.scrollTo(0,0);remember();
 }
 async function activate(){const y=restore();await ui.load();window.scrollTo(0,y);remember();}
 async function back(){if(depth>0)history.back();else await go('dashboard');}
 function reset(){ready=false;depth=0;history.replaceState(null,'','/');ui.restore(null);}
 window.addEventListener('popstate',()=>{if(!owner())return;ui.close();void activate().catch(ui.error);});
 window.addEventListener('pagehide',remember);
 window.addEventListener('pageshow',event=>{if(event.persisted&&owner())void activate().catch(ui.error);});
 return {go,push,remember,activate,back,reset};
}
